import { Stack, Button } from '@mui/material';
import {
  AppHeaderButton,
  AppHeaderContainer,
  AppHeaderNavigationContainer,
} from './Filters.component';
import { HeaderTabs } from '@/data';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProfileMenu } from './ProfileMenu';
import { NotificationMenu } from './NotificationMenu';

export const AppHeader = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <header>
      <AppHeaderContainer>
        <svg
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.083 14.5539C27.083 14.5539 23.0585 16.4746 21.3493 17.7641C19.1138 19.4508 18.4019 21.5809 15.9854 22.9989C12.7352 24.2992 12.3314 24.6153 7.61808 20.4869C5.89107 18.9745 2.04602 13.2734 2.04602 13.2734C1.51064 12.4939 0.168154 11.5041 0.807919 10.7099C1.44765 9.91569 2.8082 10.1167 3.60295 10.8081L6.49779 13.8254C7.29685 14.4393 8.46521 14.6712 9.32253 13.6581C10.543 12.1162 11.3447 10.8135 11.6003 8.91806L12.496 1.67826C12.6249 1.15225 13.0985 0.477228 13.8291 0.629685C14.5598 0.782106 14.7872 1.70354 14.684 2.24266L14.2266 9.65553C14.3022 10.2924 14.865 10.8942 15.3868 10.1355L19.4544 2.06349C19.7559 1.50095 20.465 1.12039 21.0036 1.59118C21.7106 2.20908 21.9189 2.87019 21.5467 3.30324L17.6946 11.4086C17.5535 11.8436 18.0241 12.1804 18.3847 11.9805L24.1057 5.82507C24.297 5.63633 24.8516 5.5009 25.2925 6.01547C25.7332 6.52994 25.5715 7.34294 25.3438 7.51317L19.9879 13.8548C19.628 14.5172 19.9933 14.9791 20.5878 14.9534L26.0851 12.7795C26.4953 12.5528 27.0761 12.9385 27.269 13.3392C27.3966 13.7763 27.3738 14.1931 27.0832 14.5538L27.083 14.5539Z"
            fill="currentColor"
          />
        </svg>
        <Stack direction="row" alignItems="center" gap={2}>
          <NotificationMenu />
          <ProfileMenu />
        </Stack>
      </AppHeaderContainer>
      <AppHeaderNavigationContainer>
        {HeaderTabs.map((tab) => (
          <AppHeaderButton
            disableRipple
            isActive={pathname.includes(tab.link)}
            key={tab.label}
            onClick={() => navigate(tab.link)}
          >
            {tab.icon}
            {tab.label}
          </AppHeaderButton>
        ))}
      </AppHeaderNavigationContainer>
    </header>
  );
};
